module.exports = __webpack_public_path__ + "img/hw-s1.f7539bf8.svg";